export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8951.e04b4a8d.jpg";